import type { SVGAttributes } from 'react';

export function NotFoundIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="152" height="152" fill="none" {...props} viewBox="0 0 152 152">
			<circle cx="76" cy="76" r="76" fill="currentColor" opacity=".03" />
			<circle cx="76" cy="76" r="60" fill="currentColor" opacity=".05" />
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeMiterlimit="10"
				strokeWidth="2"
				d="M106 91.6c0 7.95-6.45 14.4-14.4 14.4-4.26 0-8.07-1.86-10.71-4.8-2.28-2.55-3.69-5.91-3.69-9.6 0-7.95 6.45-14.4 14.4-14.4 4.11 0 7.83 1.74 10.47 4.53-.03 0-.03 0 0 .03 2.43 2.58 3.93 6.03 3.93 9.84m-10.56 4.02L87.85 88m7.5.09-7.59 7.62"
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M106 66.07c0 5.91-1.53 11.13-3.93 15.66-2.64-2.79-6.36-4.53-10.47-4.53-7.95 0-14.4 6.45-14.4 14.4 0 3.69 1.41 7.05 3.69 9.6-1.11.51-2.13.93-3.03 1.23-1.02.36-2.7.36-3.72 0C65.44 99.46 46 87.07 46 66.07c0-9.27 7.47-16.77 16.68-16.77 5.43 0 10.29 2.64 13.32 6.69 3.03-4.05 7.89-6.69 13.32-6.69 9.21 0 16.68 7.5 16.68 16.77"
				opacity=".4"
			/>
		</svg>
	);
}
